import script from "./CatalogSections.vue?vue&type=script&lang=ts&setup=true"
export * from "./CatalogSections.vue?vue&type=script&lang=ts&setup=true"

import "./CatalogSections.vue?vue&type=style&index=0&id=b0d071b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0d071b8"]])

export default __exports__